import CountryPageRenderer from '../components/CountryPageRenderer';
import czechRepublicData from '../data/country-pages/czech-republic';

export default function CzechRepublicCountryPage() {
  return <CountryPageRenderer data={czechRepublicData} />;
}
